import { render, staticRenderFns } from "./SliderControlButton.vue?vue&type=template&id=96558b96"
import script from "./SliderControlButton.vue?vue&type=script&lang=js"
export * from "./SliderControlButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports